<template>
  <div>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      :variant="variant"
      :disabled="disabled"
      :size="size"
      :block="block"
      @click="onClick"
    >
      <feather-icon
        :icon="icon"
        class="mr-50"
        :show-icon="showIcon"
      />
      <b-spinner
        v-if="loading"
        small
      />
      <span class="align-middle"> {{ label }}</span>
    </b-button>
  </div>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'Button',
  components: {
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    size: {
      type: String,
      required: true,
      default: 'md',
    },
    className: {
      type: String,
      required: false,
      default: 'mr-1 mt-1',
    },
    label: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: 'primary',
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    block: {
      type: Boolean,
      required: false,
      default: false,
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
